// /src/intersection-results.js

let riskScoreMass, riskScoreVol;
let c_vehicle = null;
let p_vehicle = null;
//
// Freight Mode
//
function updateFreightMode() {
   // Called when freight mode button clicked

   // Input field visability
   $('.inpCol').hide();
   if ($('#btnradio1').is(':checked')) {
      $('#inpMassCol').show();
   } else if ($('#btnradio2').is(':checked')) {
      $('#inpVolCol').show();
   } else if ($('#btnradio3').is(':checked')) {
      $('#inpTripsCol').show();
   }
   updateFreightResult();
}

function updateFreightResult() {
   if (c_vehicle && p_vehicle) {
      const freightResult = calcFreightMetrics();
      updateSummaries(freightResult);
      populateFreightTable(c_vehicle, p_vehicle, freightResult);
   }
}

function refreshResults(c, p, results) {
   c_vehicle = c;
   p_vehicle = p;
   riskScoreMass = results.relRiskMass.completeLeftTurn;
   riskScoreVol = results.relRiskVol.completeLeftTurn;

   const freightResult = calcFreightMetrics();
   updateSummaries(freightResult);
   populateFreightTable(c_vehicle, p_vehicle, freightResult);
   updateTurningTime(results);
}

function calcFreightMetrics() {
   // Generate freight metrics - uses vehicle capacities,and user freight task inputs
   const freight = getFreightData();

   const freightEquivalenceMass = p_vehicle.capacity_mass / c_vehicle.capacity_mass;
   const freightEquivalenceVol = p_vehicle.capacity_vol / c_vehicle.capacity_vol;
   const freightMetrics = {
      // The freight user inputs
      weeklyTonnes: freight.weeklyTonnes,
      weeklyVol: freight.weeklyVol,
      weeklyTrips: freight.weeklyTrips,
      // #Trips for proposed vehicle based on mass and volume equivalents based on trips per week
      weeklyTripsProposedVol: toOne(freight.weeklyTrips / freightEquivalenceVol),
      weeklyTripsProposedMass: toOne(freight.weeklyTrips / freightEquivalenceMass),

      // #Trips based on freight task volume or mass for the vehicles
      tripsMassCurr: toOne(freight.weeklyTonnes / c_vehicle.capacity_mass),
      tripsMassProp: toOne(freight.weeklyTonnes / p_vehicle.capacity_mass),
      tripsMassDiff: toOne(
         freight.weeklyTonnes / p_vehicle.capacity_mass - freight.weeklyTonnes / c_vehicle.capacity_mass
      ),
      tripsVolumeCurr: toOne(freight.weeklyVol / c_vehicle.capacity_vol),
      tripsVolumeProp: toOne(freight.weeklyVol / p_vehicle.capacity_vol),
      tripsVolumeDiff: toOne(freight.weeklyVol / p_vehicle.capacity_vol - freight.weeklyVol / c_vehicle.capacity_vol),
      equivalenceMassProp: toTwo(freightEquivalenceMass),
      equivalenceVolumeProp: toOne(freightEquivalenceVol),
   };
   return freightMetrics;
}
function getFreightData() {
   return {
      weeklyTonnes: $('#inpMass').val(),
      weeklyVol: $('#inpVol').val(),
      weeklyTrips: $('#inpTrips').val(),
   };
}

function updateSummaries(freightResult) {
   // also called when user changes freight inputs, update the freight related text (and when user changes the freight mode)
   let diff, freightSize;
   let riskScore;

   // Determine what to display based on the mode
   switch (getFreightMode()) {
      case 'mass':
         riskScore = riskScoreMass; // left turn mass risk is used for risk
         diff = freightResult.tripsMassDiff;
         freightSize = freightResult.weeklyTonnes + ' tonnes/wk freight task';
         break;
      case 'volume':
         riskScore = riskScoreVol; // left turn vol risk is used
         diff = freightResult.tripsVolumeDiff;
         freightSize = freightResult.weeklyVol + ' m3/week freight task';
         break;
      case 'trips':
         riskScore = riskScoreMass; // ?
         // weeklyTripsProposedVol or weeklyTripsProposedMass could be used?
         diff = toOne(freightResult.weeklyTripsProposedMass - freightResult.weeklyTrips);
         freightSize = freightResult.weeklyTrips + ' trips and relative payload capacity';
         break;
   }

   // Update the risk text and color
   if (riskScore <= 1.0) {
      $('#summRisk').text('less relative risk');
      $('#summRisk').css('color', 'green');
   } else {
      $('#summRisk').text('more relative exposure risk');
      $('#summRisk').css('color', 'red');
   }

   // Wording for more or less trips
   const moreLessTrips = diff > 0 ? 'more' : 'less';
   $('#summTrips').text(` ${Math.abs(diff)} ${moreLessTrips} truck trips per week`);
   $('#summSize').text(` based on ${freightSize}.`);
   setDiffColour('summTrips', diff);
}

function populateFreightTable(c, p, freightResult) {
   // also updates when freight inputs change

   // If the mode is relative trips based, use a different calculation.
   let tripsMassCurr, tripsVolumeCurr, tripsMassProp, tripsVolumeProp;
   const mode = getFreightMode();
   if (mode === 'trips') {
      tripsMassCurr = freightResult.weeklyTrips; // current vehicle has user defined fixed amount of trips
      tripsVolumeCurr = freightResult.weeklyTrips;
      tripsMassProp = freightResult.weeklyTripsProposedMass;
      tripsVolumeProp = freightResult.weeklyTripsProposedVol;
   } //for mass and volume specified
   else {
      tripsMassCurr = freightResult.tripsMassCurr;
      tripsMassProp = freightResult.tripsMassProp;
      tripsVolumeCurr = freightResult.tripsVolumeCurr;
      tripsVolumeProp = freightResult.tripsVolumeProp;
   }

   // If in mass or vol mode, hide the other row for less confusion.
   $('.tripsRow').show();
   if (mode === 'mass') {
      $('.volRow').hide();
   } else if (mode === 'volume') {
      $('.massRow').hide();
   }

   const data = {
      // About the vehicles
      DescCurr: c.description,
      DescProp: p.description,
      EngineCurr: c.engine,
      EngineProp: p.engine,
      AccessCurr: c.approved + ' - ' + c.network,
      AccessProp: p.approved + ' - ' + p.network,
      LengthCurr: c.length,
      LengthProp: p.length,
      MassCurr: c.gcm,
      MassProp: p.gcm,
      FreightMassCurr: c.capacity_mass,
      FreightMassProp: p.capacity_mass,
      EquivalenceMassProp: `(x${freightResult.equivalenceMassProp})`,

      // freight results display
      TripsMassCurr: tripsMassCurr,
      TripsMassProp: tripsMassProp,
      TripsMassDiff: diffPercentStr(tripsMassCurr, tripsMassProp),
      TripsVolumeCurr: tripsVolumeCurr,
      TripsVolumeProp: tripsVolumeProp,
      TripsVolumeDiff: diffPercentStr(tripsVolumeCurr, tripsVolumeProp),
   };

   $.each(data, function (id, value) {
      $('#' + id).text(value);
   });
   setDiffColour('TripsMassDiff', freightResult.tripsMassDiff);
   setDiffColour('TripsVolumeDiff', freightResult.tripsVolumeDiff);
}

function updateTurningTime(results) {
   updateTurningSummaryStrs(results);

   // Update values in table for left turn
   $('#left-time-complete-current').text(`${toOne(results.currentTimes.completeLeftTurn)}s`);
   $('#left-time-complete').text(`${toOne(results.proposedTimes.completeLeftTurn)}s`);
   setTimeDiff('left-time-diff', results.currentTimes.completeLeftTurn, results.proposedTimes.completeLeftTurn);
   setRisk('left-risk-mass-complete', results.relRiskMass.completeLeftTurn);

   $('#left-time-70-current').text(`${toOne(results.currentTimes.p70Left)}s`);
   $('#left-time-70').text(`${toOne(results.proposedTimes.p70Left)}s`);
   setTimeDiff('left-time-70-diff', results.currentTimes.p70Left, results.proposedTimes.p70Left);
   setRisk('left-risk-mass-70', results.relRiskMass.p70Left);

   $('#left-time-target-current').text(`${toOne(results.currentTimes.p100Left)}s`);
   $('#left-time-target').text(`${toOne(results.proposedTimes.p100Left)}s`);
   setTimeDiff('left-time-target-diff', results.currentTimes.p100Left, results.proposedTimes.p100Left);
   setRisk('left-risk-mass-target', results.relRiskMass.p100Left);

   // Update values in table for right turn
   $('#right-time-complete-current').text(`${toOne(results.currentTimes.completeRightTurn)}s`);
   $('#right-time-complete').text(`${toOne(results.proposedTimes.completeRightTurn)}s`);
   setTimeDiff('right-time-diff', results.currentTimes.completeRightTurn, results.proposedTimes.completeRightTurn);
   setRisk('right-risk-mass-complete', results.relRiskMass.completeRightTurn);

   $('#time-clear-current').text(`${toOne(results.currentTimes.carriagewayClearTime)}s`);
   $('#time-clear').text(`${toOne(results.proposedTimes.carriagewayClearTime)}s`);
   setTimeDiff(
      'right-time-clear-diff',
      results.currentTimes.carriagewayClearTime,
      results.proposedTimes.carriagewayClearTime
   );
   $('#exposure-clear').text(results.exposure.carriagewayClearTime);
   setRisk('risk-mass-clear', results.relRiskMass.carriagewayClearTime);

   $('#right-time-70-current').text(`${toOne(results.currentTimes.p70Right)}s`);
   $('#right-time-70').text(`${toOne(results.proposedTimes.p70Right)}s`);
   setTimeDiff('right-time-70-diff', results.currentTimes.p70Right, results.proposedTimes.p70Right);
   setRisk('right-risk-mass-70', results.relRiskMass.p70Right);

   $('#right-time-target-current').text(`${toOne(results.currentTimes.p100Right)}s`);
   $('#right-time-target').text(`${toOne(results.proposedTimes.p100Right)}s`);
   setTimeDiff('right-time-target-diff', results.currentTimes.p100Right, results.proposedTimes.p100Right);
   setRisk('right-risk-mass-target', results.relRiskMass.p100Right);

   // Warnings if target speed not met.
   if (results.proposedTimes.p100IsReached) $('.p100warning').hide();
   else $('.p100warning').show();
   if (results.proposedTimes.p70IsReached) $('.p70warning').hide();
   else $('.p70warning').show();
}

function updateTurningSummaryStrs(results) {
   const completediffTimeLeft = results.proposedTimes.completeLeftTurn - results.currentTimes.completeLeftTurn;
   const targetdiffTimeLeft = results.proposedTimes.p100Left - results.currentTimes.p100Left;
   const leftCompleted = `The proposed vehicle took ${moreLessTimeStr(completediffTimeLeft)}
    to clear the intersection after a left turn`;
   let leftReached = ` and took ${moreLessTimeStr(targetdiffTimeLeft)}
   to reach the target speed.`;
   if (!results.proposedTimes.p100IsReached || !results.proposedTimes.p100IsReached)
      leftReached = `.  Note that at least one vehicle didn't reach target speed.`;
   $('#leftSummaryMessage').text(leftCompleted + leftReached);

   const completediffTimeRight = results.proposedTimes.completeRightTurn - results.currentTimes.completeRightTurn;
   const targetdiffTimeRight = results.proposedTimes.p100Right - results.currentTimes.p100Right;
   const rightCompleted = `The proposed vehicle took ${moreLessTimeStr(completediffTimeRight)}
    to clear the intersection after a right turn`;
   let rightReached = ` and took ${moreLessTimeStr(targetdiffTimeRight)}
    to reach the target speed.`;
   if (!results.proposedTimes.p100IsReached || !results.proposedTimes.p100IsReached)
      rightReached = `. Note that at least one vehicle didn't reach target speed.`;
   $('#rightSummaryMessage').text(rightCompleted + rightReached);
}

// helpers

function getFreightMode() {
   if ($('#btnradio1').is(':checked')) return 'mass';
   else if ($('#btnradio2').is(':checked')) return 'volume';
   else return 'trips';
}

function moreLessTimeStr(diff) {
   const morlesss = diff > 0 ? 'more' : 'less';
   const absDiff = Math.abs(toOne(diff));
   return `${absDiff}s ${morlesss}`;
}

function setTimeDiff(diffId, value1, value2) {
   // calculate difference for times, format and color
   const diff = value2 - value1;
   const diffStr = diff > 0 ? '+' + diff.toFixed(1) : diff.toFixed(1);
   $('#' + diffId).text(`(${diffStr}s)`);
   setDiffColour(diffId, diff);
}

function setRisk(riskId, val) {
   // format and color, shows as a percentage
   const riskPer = convertRiskScoreToPercentage(val);
   $('#' + riskId).text(riskPer);
   if (val > 1.001) {
      $('#' + riskId).css('color', 'red');
   } else {
      $('#' + riskId).css('color', 'green');
   }
}

function diffPercentStr(value1, value2) {
   if (!isNaN(value1) && !isNaN(value2)) {
      const diff = value2 - value1;
      const diffStr = diff > 0 ? '+' + diff.toFixed(1) : diff.toFixed(1);

      const diffPercent = diff / value1;
      const percentStr = ' (' + (diffPercent * 100).toFixed(1) + '%)';
      return diffStr + percentStr;
   }
}

function setDiffColour(diffId, diff) {
   if (diff > 0) {
      $('#' + diffId).css('color', 'red');
   } else if (diff < 0) {
      $('#' + diffId).css('color', 'green');
   }
}

function toOne(floatValue) {
   const rounded = Math.round(floatValue * 10) / 10;
   return rounded;
}
function toTwo(floatValue) {
   const rounded = Math.round(floatValue * 100) / 100;
   return rounded;
}

function convertRiskScoreToPercentage(riskScore) {
   let percentage;

   if (riskScore < 1.0) {
      // Less risk so risk improvement
      percentage = Math.round((1 - riskScore) * 100);
      return `-${percentage}%`;
   } else {
      // More risk
      percentage = Math.round((riskScore - 1) * 100);
      return `+${percentage}%`;
   }
}

export { updateFreightMode, updateFreightResult, refreshResults };
